export default __webpack_public_path__ + "static/media/arrow_down.b9efb5f6.svg";